import { render, staticRenderFns } from "./gallery.vue?vue&type=template&id=591fc866&scoped=true&"
import script from "./gallery.vue?vue&type=script&lang=js&"
export * from "./gallery.vue?vue&type=script&lang=js&"
import style1 from "./gallery.vue?vue&type=style&index=1&id=591fc866&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591fc866",
  null
  
)

export default component.exports